import { createClient } from '@supabase/supabase-js';

// Initialize Supabase Client
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const authService = {
    // Get current session
    getSession: async () => {
        const { data } = await supabase.auth.getSession();
        return data.session;
    },

    // Listen for auth changes
    onAuthStateChange: (callback: any) => {
        return supabase.auth.onAuthStateChange(callback);
    },

    // Sign in with email and password
    signInWithEmail: async (email: string, password: string) => {
        const { data, error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });
        if (error) throw error;
        // Normalize response to match expectations if needed
        return data;
    },

    // Sign up
    signUp: async (email: string, password: string, metadata?: any) => {
        const { data, error } = await supabase.auth.signUp({
            email,
            password,
            options: {
                data: metadata,
            },
        });
        if (error) throw error;
        return data;
    },

    // Sign out
    signOut: async () => {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
    },

    // Social Login
    signInWithProvider: async (provider: 'google' | 'github' | 'linkedin') => {
        const { data, error } = await supabase.auth.signInWithOAuth({
            provider: provider,
            options: {
                redirectTo: `${window.location.origin}/dashboard`
            }
        });
        if (error) throw error;
        return data;
    },

    // Demo Login (Simulated or via API)
    demoLogin: async (role: string) => {
        try {
            // Try calling the express API endpoint
            // Note: We use fetch directly to avoid circular dependencies with api.ts if it exists
            const response = await fetch('/api/auth/demo-login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ role })
            });

            if (response.ok) {
                return await response.json();
            }
        } catch (err) {
            console.warn('Demo login API failed, falling back to mock', err);
        }

        // Fallback Mock for development/offline
        return {
            user: {
                id: 'demo-user-id',
                email: 'demo@example.com',
                app_metadata: { role: role || 'user' },
                user_metadata: { first_name: 'Demo', last_name: 'User' }
            },
            access_token: 'demo-token-123',
            session: { access_token: 'demo-token-123' }
        };
    }
};
